export const silaAnimalsColumns = [
  {
    name: "DGR",
    uid: "dgr",
    sortable: true,
    description: "Genetic Registry ID",
  },
  { name: "Name", uid: "name", sortable: true, description: "Animal Name" },
  { name: "Sex", uid: "sex", sortable: true, description: "Sex of the animal" },
  {
    name: "Birth Date",
    uid: "birthDate",
    sortable: true,
    description: "Date of birth",
  },
  {
    name: "Animal Status",
    uid: "animalStatus",
    sortable: true,
    description: "Current status of the animal",
  },
  {
    name: "Phases",
    uid: "phases",
    sortable: true,
    description: "Growth phases of the animal",
  },
  {
    name: "Breed",
    uid: "breed",
    sortable: true,
    description: "Breed of the animal",
  },
  {
    name: "Bull Type",
    uid: "bullType",
    sortable: true,
    description: "Bull type",
  },
  {
    name: "ADG",
    uid: "adg",
    sortable: true,
    description: "Average daily gain",
  },
  {
    name: "W120",
    uid: "w120",
    sortable: true,
    description: "Weight at 120 days",
  },
  { name: "WW", uid: "ww", sortable: true, description: "Weaning weight" },
  { name: "YW", uid: "yw", sortable: true, description: "Yearling weight" },
  {
    name: "PMWG",
    uid: "pmwg",
    sortable: true,
    description: "Post-weaning gain",
  },
  {
    name: "Coat Color",
    uid: "coatColor",
    sortable: true,
    description: "Coat color",
  },
  {
    name: "Size",
    uid: "size",
    sortable: true,
    description: "Size of the animal",
  },
  {
    name: "Weight",
    uid: "weight",
    sortable: true,
    description: "Current weight",
  },
  {
    name: "Paternal Nucleus",
    uid: "paternalNucleus",
    sortable: true,
    description: "Paternal nucleus",
  },
  {
    name: "Paternal Type",
    uid: "paternalType",
    sortable: true,
    description: "Paternal type",
  },
  {
    name: "Breeding Type",
    uid: "breedingType",
    sortable: true,
    description: "Type of breeding",
  },
  {
    name: "Racial Composition",
    uid: "racialComposition",
    sortable: true,
    description: "Breed composition",
  },
  {
    name: "Birth Condition",
    uid: "birthCondition",
    sortable: true,
    description: "Birth condition",
  },
  {
    name: "Dam Name",
    uid: "damName",
    sortable: true,
    description: "Name of the dam",
  },
  {
    name: "Dam DGR",
    uid: "damDGR",
    sortable: true,
    description: "DGR of the dam",
  },
  {
    name: "Dam Breed",
    uid: "damBreed",
    sortable: true,
    description: "Breed of the dam",
  },
  {
    name: "Dam Birth Date",
    uid: "damBirthDate",
    sortable: true,
    description: "Birth date of the dam",
  },
  {
    name: "Sire DGR",
    uid: "sireDGR",
    sortable: true,
    description: "DGR of the sire",
  },
  {
    name: "Sire Name",
    uid: "sireName",
    sortable: true,
    description: "Name of the sire",
  },
  {
    name: "Sire Breed",
    uid: "sireBreed",
    sortable: true,
    description: "Breed of the sire",
  },
  {
    name: "Sire Birth Date",
    uid: "sireBirthDate",
    sortable: true,
    description: "Birth date of the sire",
  },
  {
    name: "Paternal GrandDam DGR",
    uid: "paternalGrandDamDGR",
    sortable: true,
    description: "DGR of paternal grand dam",
  },
  {
    name: "Paternal GrandDam Name",
    uid: "paternalGrandDamName",
    sortable: true,
    description: "Name of paternal grand dam",
  },
  {
    name: "Paternal GrandDam Breed",
    uid: "paternalGrandDamBreed",
    sortable: true,
    description: "Breed of paternal grand dam",
  },
  {
    name: "Paternal GrandSire DGR",
    uid: "paternalGrandSireDGR",
    sortable: true,
    description: "DGR of paternal grand sire",
  },
  {
    name: "Paternal GrandSire Name",
    uid: "paternalGrandSireName",
    sortable: true,
    description: "Name of paternal grand sire",
  },
  {
    name: "Paternal GrandSire Breed",
    uid: "paternalGrandSireBreed",
    sortable: true,
    description: "Breed of paternal grand sire",
  },
  {
    name: "Maternal GrandDam DGR",
    uid: "maternalGrandDamDGR",
    sortable: true,
    description: "DGR of maternal grand dam",
  },
  {
    name: "Maternal GrandDam Name",
    uid: "maternalGrandDamName",
    sortable: true,
    description: "Name of maternal grand dam",
  },
  {
    name: "Maternal GrandDam Breed",
    uid: "maternalGrandDamBreed",
    sortable: true,
    description: "Breed of maternal grand dam",
  },
  {
    name: "Maternal GrandSire DGR",
    uid: "maternalGrandSireDGR",
    sortable: true,
    description: "DGR of maternal grand sire",
  },
  {
    name: "Maternal GrandSire Name",
    uid: "maternalGrandSireName",
    sortable: true,
    description: "Name of maternal grand sire",
  },
  {
    name: "Maternal GrandSire Breed",
    uid: "maternalGrandSireBreed",
    sortable: true,
    description: "Breed of maternal grand sire",
  },
  { name: "Farm", uid: "farm", sortable: true, description: "Farm name" },
  {
    name: "Evaluation",
    uid: "evaluation",
    sortable: true,
    description: "Evaluation",
  },
  {
    name: "Assigned Supervisor",
    uid: "assignedSupervisor",
    sortable: true,
    description: "Assigned supervisor",
  },
  {
    name: "Cattle Class",
    uid: "cattleClass",
    sortable: true,
    description: "Cattle class",
  },
  {
    name: "Slaughter Info",
    uid: "slaughterInfo",
    sortable: true,
    description: "Slaughter info",
  },
  {
    name: "Diagnosis",
    uid: "diagnosis",
    sortable: true,
    description: "Diagnosis",
  },
  { name: "Status", uid: "status", sortable: true, description: "Status" },
  {
    name: "Insemination Program",
    uid: "inseminationProgram",
    sortable: true,
    description: "Insemination program",
  },
  {
    name: "Number Offspring",
    uid: "numberOffspring",
    sortable: true,
    description: "Number of offspring",
  },
  {
    name: "Index Efficiency",
    uid: "indexEfficiency",
    sortable: true,
    description: "Index efficiency",
  },
  {
    name: "Actions",
    uid: "actions",
    sortable: true,
    description: "Actions",
  },
]


export const INITIAL_SILA_ANIMAL_COLUMNS = [
  "dgr",
  "birthDate",
  "sex",
  "name",
  "age",
  "breed",
  "bullType",
  "adg",
  "milkAcc",
  "age1pAcc",
  "ebiAcc",
  "betaLac",
  "kappaC",
  "betaC",
  "w120",
  "ww",
  "pw",
  "yw",
  "pmwg",
  "coatColor",
  "size",
  "weight",
  "paternalNucleus",
  "paternalType",
  "breedingType",
  "vaccinations",
  "racialComposition",
  "birthCondition",
  "damName",
  "damDGR",
  "damBreed",
  "damBirthDate",
  "sireDGR",
  "sireName",
  "sireBreed",
  "sireBirthDate",
  "paternalGrandDamDGR",
  "paternalGrandDamName",
  "paternalGrandDamBreed",
  "paternalGrandSireDGR",
  "paternalGrandSireName",
  "paternalGrandSireBreed",
  "maternalGrandDamDGR",
  "maternalGrandDamName",
  "maternalGrandDamBreed",
  "maternalGrandSireDGR",
  "maternalGrandSireName",
  "maternalGrandSireBreed",
  "animalStatus",
  "birthWeight",
  "farmerID",
  "farmID",
  "url",
  "imageUrls",
  "videos",
  "farm",
  "evaluation",
  "assignedSupervisor",
  "cattleClass",
  "phases",
  "slaughterInfo",
  "diagnosis",
  "status",
  "inseminationProgram",
  "numberOffspring",
  "indexEfficiency",
  "length_of_rump",
  "height_of_rump",
  "lower_height",
  "back_height",
  "body_length",
  "rib_depth",
  "chest_perimeter",
  "body_width",
  "scrotal_circumference",
  "mw_me_epd",
  "mw_me_acc",
  "mw_me_deca",
  "bw_de_epd",
  "bw_de_acc",
  "bw_de_deca",
  "ww_de_epd",
  "ww_de_acc",
  "ww_de_deca",
  "aw_de_epd",
  "aw_de_acc",
  "aw_de_deca",
  "yw_de_epd",
  "yw_de_acc",
  "yw_de_deca",
  "sc365_epd",
  "sc365_acc",
  "sc365_deca",
  "sc450_epd",
  "sc450_acc",
  "sc450_deca",
  "bs_epd",
  "bs_acc",
  "bs_deca",
  "prec_epd",
  "prec_acc",
  "prec_deca",
  "musc_epd",
  "musc_acc",
  "musc_deca",
  "rea_epd",
  "rea_acc",
  "rea_deca",
  "finishing_epd",
  "finishing_acc",
  "finishing_deca",
  "mar_epd",
  "mar_acc",
  "mar_deca",
  "iabcz_epd",
  "iabcz_acc",
  "iabcz_deca",
  "actions",
]
